// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErdstallObject = exports.registerErdstallType = void 0;
const typedjson_1 = require("../export/typedjson");
const util_1 = require("./util");
const objectImpls = new Map();
function registerErdstallType(typeName, typeClass) {
    objectImpls.set(typeName, typeClass);
}
exports.registerErdstallType = registerErdstallType;
/** Base type for all Erdstall messages. */
let ErdstallObject = class ErdstallObject {
    static fromJSON(js) {
        let data = JSON.stringify(js.data);
        if (!objectImpls.has(js.type)) {
            throw new Error(`unknown erdstall object type "${js.type}"`);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return typedjson_1.TypedJSON.parse(data, objectImpls.get(js.type));
    }
    static toJSON(me) {
        return {
            type: me.objectTypeName(),
            data: JSON.parse(typedjson_1.TypedJSON.stringify(me, me.objectType())),
        };
    }
};
ErdstallObject = __decorate([
    typedjson_1.jsonObject
], ErdstallObject);
exports.ErdstallObject = ErdstallObject;
util_1.customJSON(ErdstallObject);
//# sourceMappingURL=object.js.map